export enum SinceSentenceKey {
  MARKETED = 'marketed',
  SENT = 'sent',
  SOLD = 'sold'
}
